export const ZIPPY_BRAND_COLOR = '#476CEB';

/**
 * Z mark lifted from product logo assets, with a square viewBox centred on the
 * glyph so it can be dropped into any square slot. Matches merchant dashboard.
 */
const Z_MARK_VIEW_BOX = '-1 20.86 60 60';
const Z_MARK_PATH =
  'M16.8831 21.5476C16.3856 21.5476 15.9085 21.7452 15.5567 22.097L0.549704 37.104C0.0132083 37.6405 -0.147283 38.4474 0.143066 39.1483C0.433416 39.8493 1.11743 40.3063 1.87615 40.3063H26.5982L2.74743 64.1571C0.0649471 66.8395 -0.737512 70.8738 0.714236 74.3786C2.16598 77.8834 5.58604 80.1686 9.37964 80.1686H41.7385C42.236 80.1686 42.7131 79.971 43.0649 79.6192L58.0719 64.6122C58.6084 64.0757 58.7689 63.2689 58.4785 62.5679C58.1882 61.867 57.5042 61.4099 56.7455 61.4099H32.0234L55.8742 37.5592C58.5567 34.8767 59.3591 30.8425 57.9074 27.3376C56.4556 23.8328 53.0356 21.5476 49.242 21.5476H16.8831ZM5.11632 64.1759L28.3783 40.3812H30.6653L5.11632 64.1759ZM30.1464 61.4059L53.4083 37.6111L27.8594 61.4059H30.1464Z';

/** Share of the QR width taken by the logo badge. Safe at error level H. */
const BADGE_RATIO = 0.24;

function parseViewBoxSize(svg: string): number | null {
  const match = /viewBox="0 0 ([\d.]+) [\d.]+"/.exec(svg);
  return match ? Number(match[1]) : null;
}

/** White plate + centred Z mark, sized relative to the QR viewBox. */
export function buildLogoBadge(qrSize: number): string {
  const badge = qrSize * BADGE_RATIO;
  const offset = (qrSize - badge) / 2;
  const plate = badge * 1.18;
  const plateOffset = (qrSize - plate) / 2;
  const markInset = badge * 0.16;

  return [
    '<g shape-rendering="geometricPrecision">',
    `<rect x="${plateOffset}" y="${plateOffset}" width="${plate}" height="${plate}" rx="${plate * 0.22}" fill="#ffffff"/>`,
    `<svg x="${offset + markInset}" y="${offset + markInset}" width="${badge - markInset * 2}" height="${badge - markInset * 2}" viewBox="${Z_MARK_VIEW_BOX}">`,
    `<path d="${Z_MARK_PATH}" fill="${ZIPPY_BRAND_COLOR}"/>`,
    '</svg>',
    '</g>',
  ].join('');
}

/** Injects the branded logo badge into a QR SVG string before the closing tag. */
export function embedLogoInQrSvg(svg: string): string {
  const size = parseViewBoxSize(svg);
  if (!size) {
    return svg;
  }
  return svg.replace('</svg>', `${buildLogoBadge(size)}</svg>`);
}

/** Muted footer lock icon — uses currentColor. */
export function renderSecureLockSvg(): string {
  return `<svg class="zippy-brand-lock" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M7 10V8a5 5 0 0 1 10 0v2" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/><rect x="5" y="10" width="14" height="11" rx="2.5" stroke="currentColor" stroke-width="1.75"/><circle cx="12" cy="15.5" r="1.25" fill="currentColor"/></svg>`;
}
